import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "AppsPage",

	metaInfo: { title: "Apps" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Cubic Feet Calculator",
				to: { name: "cubicFeetCalculator" }
			},
			{
				title: "Margin Calculator",
				to: { name: "marginCalculator" }
			},
			{
				title: "Sealant Calculator",
				to: { name: "sealantCalculator" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
